module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAJ1BMVEXSEDQAfjqj0Lj///9arIALhELB4M/b7eOVya1TqHpAnmvE4dElkVdr6xzwAAAAhElEQVR4Ae2VxRVCURDF6ADXLRXMCQ5d0jA1BPt2s8+T0dEACSGEqWUSpVFlBgenzOHobplDuYet4Cz/Asjvz+EilT2UVACZlzmUVJ5eAaY/V3ZemcPdKw+vVFsV/xfu7+Wl+YLxlez7RbxM9L6eMH6O+WnpZ7Kf/H6/dGlXRhkeIYTwAuFxsTBoZpYaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Maldives.png
// module id = 592
// module chunks = 0